import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";
import LeadDetail from "./leadDetail";

const MySwal = withReactContent(Swal2);

const TaskCalendar = (props) => {
  const [loading, setLoading] = useState(true);
  const [taskOption, setTaskOption] = useState("PENDING");
  const [tasks, setTasks] = useState([]);
  const [showLeadDetail, setShowLeadDetail] = useState(false);
  const [showLeadDetailId, setShowLeadDetailId] = useState("");

  const fetchTasksPending = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getTasksPending", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTasks(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchTasksFinished = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getTasksFinished", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTasks(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const acceptTask = async (e) => {
    var body = { id: e.target.value };

    await fetch("https://apisellcrm.ftpeople.pl/acceptTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zadanie",
          text: "wykonane",
        }).then(async (result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const getData = (e) => {
    setLoading(true);
    if (e) {
      if (e.target.value === "PENDING") {
        setTaskOption(e.target.value);
        fetchTasksPending();
      } else {
        setTaskOption(e.target.value);
        fetchTasksFinished();
      }
    } else {
      fetchTasksPending();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const tasksBody = (
    <>
      <table
        style={{ marginTop: "0vh", fontSize: ".8vw" }}
        className="clients_table"
      >
        <tr key={0}>
          <th>zadanie</th>
          <th>klient</th>
          <th>numer telefonu</th>
          <th>adres e-mail</th>
          <th>data realizacji</th>
          <th>osoba odpowiedzialna</th>
          <th>akcja</th>
        </tr>
        {tasks
          .sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          })
          .map((el, index) => (
            <>
              <tr id={""} key={el.id}>
                <td style={{ textAlign: "left" }}>{el.task}</td>
                <td style={{ textAlign: "left" }}>{el.leadName}</td>
                <td style={{ textAlign: "left" }}>{el.phone}</td>
                <td style={{ textAlign: "left" }}>{el.mail}</td>
                <td style={{ textAlign: "left" }}>{el.date}</td>
                <td style={{ textAlign: "left" }}>{el.userName}</td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {taskOption === "PENDING" ? (
                      <>
                        <button
                          className="loginButtonLogin"
                          value="yes"
                          style={{
                            margin: "0",
                            backgroundColor: "green",
                            borderColor: "green",
                            width: "100%",
                            padding: "5px",
                            height: "auto",
                            fontSize: ".6vw",
                          }}
                          value={el.id}
                          onClick={acceptTask}
                        >
                          wykonaj
                        </button>
                      </>
                    ) : (
                      ""
                    )}

                    <button
                      className="loginButtonLogin"
                      value="yes"
                      style={{
                        margin: "0",
                        backgroundColor: "blue",
                        borderColor: "blue",
                        width: "100%",
                        padding: "5px",
                        height: "auto",
                        fontSize: ".6vw",
                      }}
                      value={el.leadId}
                      onClick={(e) => {
                        setShowLeadDetailId({ id: +e.target.value });
                        setShowLeadDetail(true);
                      }}
                    >
                      zobacz lead
                    </button>
                  </div>
                </td>
              </tr>
            </>
          ))}
      </table>
    </>
  );

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          {showLeadDetail ? (
            <>
              <LeadDetail
                close={() => {
                  setShowLeadDetail(false);
                  setShowLeadDetailId("");
                }}
                lead={showLeadDetailId}
                user={props.user}
              />
            </>
          ) : (
            <>
              <div
                style={{
                  backgroundColor: "white",
                  top: "0",
                  paddingTop: "2vh",
                  paddingBottom: "3vh",
                  paddingLeft: "2vw",
                  paddingRight: "2vw",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "1vw",
                  }}
                >
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "green",
                      borderColor: "green",
                      width: "180px",
                    }}
                    onClick={getData}
                  >
                    ODŚWIEŻ
                  </button>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "1vw",
                    marginTop: "3vh",
                  }}
                >
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "orange",
                      borderColor: "orange",
                      width: "250px",
                    }}
                    value={"PENDING"}
                    onClick={getData}
                  >
                    ZADANIA DO WYKONANIA
                  </button>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "blue",
                      borderColor: "blue",
                      width: "250px",
                    }}
                    value={"FINISHED"}
                    onClick={getData}
                  >
                    ZADANIA WYKONANE
                  </button>
                </div>
              </div>
              <div
                style={{
                  paddingTop: "2vh",
                  paddingBottom: "2vh",
                  paddingLeft: "2vw",
                  paddingRight: "2vw",
                }}
              >
                {tasksBody}
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default TaskCalendar;
